module.exports = __webpack_public_path__ + "img/outside_logo.42043dbf.jpg";